import "../../vendor/perfect-scrollbar.css";
import SidebarNavSection from "./SidebarNavSection";
import { List } from "@mui/material";
import { useTheme } from "@mui/material/styles";
import useMediaQuery from "@mui/material/useMediaQuery";
import React from "react";
import ReactPerfectScrollbar from "react-perfect-scrollbar";
import styled, { css } from "styled-components/macro";

const baseScrollbar = css`
  background-color: ${(props) => props.theme.palette.sidebar.background};
  border-right: 1px solid ${(props) => props.theme.palette.sidebar.border};
  height: 100%;
`;

const Scrollbar = styled.div`
  ${baseScrollbar}
`;

const PerfectScrollbar = styled(ReactPerfectScrollbar)`
  ${baseScrollbar}
`;

const Items = styled.div`
  padding-top: ${(props) => props.theme.spacing(2.5)};
  padding-bottom: ${(props) => props.theme.spacing(2.5)};
`;

const SidebarNav = ({ navConfig }) => {
  const theme = useTheme();
  const matches = useMediaQuery(theme.breakpoints.up("md"));
  const ScrollbarComponent = matches ? PerfectScrollbar : Scrollbar;

  return (
    <ScrollbarComponent>
      <List disablePadding>
        <Items>
          {navConfig.map((section, idx) => (
            <SidebarNavSection
              key={idx}
              title={section.section}
              pages={section.items}
            />
          ))}
        </Items>
      </List>
    </ScrollbarComponent>
  );
};

export default SidebarNav;
